import createDataContext from './createDataContext';
import { api } from '../api/api';

const affIdsReducer = (state, action) => {
  switch (action.type) {
    case 'REQUEST':
      return {
        ...state,
        loading: true,
        error: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        loading: false,
        affIds: action.payload,
      };
    case 'ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const loadAffIds = (dispatch) => async (data) => {
  try {
    dispatch({
      type: 'REQUEST',
    });
    const response = await api.get('/affIds', {
      params: data,
    });
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to load aff ids',
    });
  }
};

export const { Context, Provider } = createDataContext(
  affIdsReducer,
  {
    loadAffIds,
  },
  {
    affIds: [],
    error: '',
    loading: false,
  }
);
